// Update SellingPlan Data on Product Page
document.addEventListener('DOMContentLoaded', function () {
  const _this = document.querySelector('.product');
  console.info("(selling-plan-pdp.js)")

  if (_this) {
    if (_this.querySelector('.productScripting')) {
      const productDataScript = _this.querySelector('.productScripting');
      const productData = JSON.parse(productDataScript.querySelector('[type="application/json"]').textContent);
      const SellingPlanRadioButtons = _this.querySelectorAll("[skio-plan-picker][skio-auto-init] [skio-group-container]");
      if (SellingPlanRadioButtons) {
        SellingPlanRadioButtons.forEach(radio => radio.addEventListener('click', UpdatePrice.bind(this)), true);
      }

      setTimeout(() => {
        if (window.location.href.includes('?selling_plan')) {
          const selling_buttons = Array.from(SellingPlanRadioButtons);
          const checked_button = selling_buttons.find(btn => btn.querySelector('input').hasAttribute('checked'));
          if (checked_button) {
            checked_button.click();
          }
        }
      }, 100);

      function UpdatePrice(event) {
        const target = event.currentTarget;
        const sellingPrice = productData.selling_plan_allocations[0].price;
        const MainPrice = productData.price;
        const comparePrice = productData.compare_at_price + (window.Zipify?.OCU?.api?._widgetWasTotal ?? 0);
        const widgetTotalPrice = MainPrice + (window.Zipify?.OCU?.api._widgetTotal ?? 0);
        const widgetSellingPrice = sellingPrice + (window.Zipify?.OCU?.api._widgetTotal ?? 0);

        const saleTagElements = _this.querySelectorAll(".price-item__sale");
        if (target) {
          const targetInput = target.querySelector('input');
          if (targetInput.hasAttribute('checked')) {
            let subscriptionSaveAmount = comparePrice - sellingPrice - (window.Zipify?.OCU?.api._widgetTotal ?? 0);
            _this.querySelectorAll(".price-item.price-item_first").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(widgetSellingPrice, window.Shopify.money_format)));
            _this.querySelectorAll(".price-item--compare_at_price").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(comparePrice, window.Shopify.money_format)));
            saleTagElements.forEach((saleTagElement) => (saleTagElement.innerHTML = `Save ${window.Shopify.formatMoney(subscriptionSaveAmount, window.Shopify.money_format)}`));
          } else {
            let subscriptionSaveAmount = comparePrice - MainPrice - (window.Zipify?.OCU?.api._widgetTotal ?? 0);
            _this.querySelectorAll(".price-item.price-item_first").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(widgetTotalPrice, window.Shopify.money_format)));
            _this.querySelectorAll(".price-item--compare_at_price").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(comparePrice, window.Shopify.money_format)));
            saleTagElements.forEach((saleTagElement) => (saleTagElement.innerHTML = `Save ${window.Shopify.formatMoney(subscriptionSaveAmount, window.Shopify.money_format)}`));
          }
        }
      }
      if (window.Zipify?.OCU?.api) Zipify.OCU.api._updatePrice = UpdatePrice;
    }
  }
});